import { useCallback } from "react";
import { useApi } from "../../../hooks/useApi";
import { stringify } from "query-string";
import { urlReplacer } from "../../../utils";
import { ApiRoutes } from "../../../constants/apiRoutes";

export default function () {
  const { request } = useApi();
  return {
    fetchAll: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: ApiRoutes.ACADEMICS_HIGHER + stringify(filter),
        });
      },
      [request],
    ),

    activate: useCallback(
      async (id) => {
        return request({
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.ACTIVATE_ACADEMIC_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    deactivate: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.DEACTIVATE_ACADEMIC_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    fetchAppCount: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${
            ApiRoutes.GET_APPLICATION_COUNT_FOR_DEACTIVATION_HIGHER +
            stringify(filter)
          }`,
        });
      },
      [request],
    ),

    deleteOne: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_ACADEMIC_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_ACADEMIC_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CREATE_ACADEMIC_HIGHER,
        });
      },
      [request],
    ),

    addWithAI: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.ADD_PROGRAMS_WITH_AI_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    update: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "PUT",
          url: ApiRoutes.UPDATE_ACADEMIC_HIGHER,
        });
      },
      [request],
    ),
  };
}
